const theme = {
  colors: {
    // Baza: e ndritshme dhe e ajrosur — produkt shëndeti, jo luksi i errët.
    bg: "#FBFAF7",
    bgAlt: "#F3F1EB",
    surface: "#FFFFFF",

    ink: "#1C1B18",
    inkSoft: "#5A574F",
    inkFaint: "#918D82",

    line: "#E4E0D6",

    // Jeshile e qetë bimore — identiteti i markës kur asnjë produkt nuk është aktiv.
    brand: "#3F6B52",
    brandDeep: "#2A4A38",
    brandSoft: "#DCE7DF",

    accentWarm: "#C98B4B",
    whatsapp: "#25D366",
  },

  font: {
    display: "'Fraunces', Georgia, 'Times New Roman', serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },

  // Tipografi fluide — pa breakpoint-e për madhësinë e shkronjave.
  size: {
    xs: "clamp(0.75rem, 0.72rem + 0.15vw, 0.82rem)",
    sm: "clamp(0.86rem, 0.83rem + 0.18vw, 0.95rem)",
    base: "clamp(1rem, 0.96rem + 0.22vw, 1.09rem)",
    lg: "clamp(1.15rem, 1.08rem + 0.35vw, 1.35rem)",
    xl: "clamp(1.4rem, 1.25rem + 0.7vw, 1.85rem)",
    h3: "clamp(1.6rem, 1.35rem + 1.1vw, 2.3rem)",
    h2: "clamp(2rem, 1.55rem + 2vw, 3.3rem)",
    h1: "clamp(2.6rem, 1.8rem + 3.6vw, 5rem)",
  },

  space: (n) => `${n * 8}px`,

  radius: {
    sm: "8px",
    md: "16px",
    lg: "28px",
    pill: "999px",
  },

  shadow: {
    soft: "0 2px 8px rgba(28, 27, 24, 0.04), 0 12px 32px rgba(28, 27, 24, 0.06)",
    lift: "0 4px 14px rgba(28, 27, 24, 0.07), 0 24px 56px rgba(28, 27, 24, 0.10)",
    product: "0 30px 60px -20px rgba(28, 27, 24, 0.35)",
  },

  maxWidth: "1240px",
  narrow: "760px",

  // Ndërprerjet: mobile-first, prandaj të gjitha janë min-width.
  bp: {
    sm: "@media (min-width: 560px)",
    md: "@media (min-width: 860px)",
    lg: "@media (min-width: 1140px)",
  },

  ease: "cubic-bezier(0.22, 1, 0.36, 1)",
};

export default theme;
